// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"ce5905ff","477":"ddbc99ed","539":"2469f9e2","596":"acbf297f","787":"8be9c5f0","808":"38889480"}[chunkId] + ".chunk.js";
};